import { OvlAddComponent, OvlAddDialog } from "./global/globals"
import { SYSDialog } from "./library/dialog/dialog"
import { SYSDialogHolder } from "./library/dialog/sysdialogholder"
import { SYSEditorAsset } from "./library/forms/controls/asset"
import { SYSTableSettingsColumnFilterDialog } from "./library/table/tablerowheadermenu/tablesettings/columnfilter/columnfilter"
import { SYSTableSettingsFilterSortDialog } from "./library/table/tablerowheadermenu/tablesettings/filtersort/tabledialog"

import { SYSCheckbox } from "./library/forms/controls/checkbox"
import { SYSDate } from "./library/forms/controls/date"
import { SYSDateTime } from "./library/forms/controls/datetime"
import { SYSFormValidationHint } from "./library/forms/controls/formvalidationhint"
import { SYSListControl } from "./library/forms/controls/listcontrol"
import { SYSOption } from "./library/forms/controls/option"
import { SYSCustomValueHint } from "./library/forms/controls/parts/controlcustomvaluehint"
import { SYSControlLabel } from "./library/forms/controls/parts/controllabel"
import { SYSValidationHint } from "./library/forms/controls/parts/controlvalidationhint"
import { SYSHitList } from "./library/forms/controls/parts/hitlist"
import { SYSHitListDialog } from "./library/forms/controls/parts/hitlistdialog/hitlistdialog"
import { SYSOkCancelDeleteFooter } from "./library/forms/controls/parts/okcanceldeletefooter"
import { SYSTextArea } from "./library/forms/controls/textarea"
import { SYSTextbox } from "./library/forms/controls/textbox"
import { SYSTime } from "./library/forms/controls/time"
import { SYSSnack } from "./library/snack/snack"
import { SYSDialogContainer } from "./library/specialcontainers/dialogcontainer/dialogcontainter"
import { SYSScreenContainer } from "./library/specialcontainers/screencontainer/screencontainter"
import { SYSTableHeaderMenu } from "./library/table/headermenu"

import { SYSTableNavControl } from "./library/table/navcontrol"
import { SYSTableRow } from "./library/table/row"
import { SYSTableRowControl } from "./library/table/rowcontrol"
import { SYSTableRowForm } from "./library/table/rowform"
import { SYSTableRowFormBig } from "./library/table/rowformbig"
import { SYSTableRowSaveCancel } from "./library/table/rowformsavecancel"
import { SYSTableValidationSummaryRow } from "./library/table/rowvalidationsummary"
import { SYSTableRowWrapper } from "./library/table/rowwrapper"
import { SYSTableHeader } from "./library/table/table"
/*import { SYSTableRowTableRowDetailView } from "./library/table/tablerowdetailview/tablerowdetailview"*/
import { SYSTableRowEditFormDialog } from "./library/table/tableroweditformdialog/tableroweditformdialog"
import { SYSHeaderMenuColumnFilter } from "./library/table/tablerowheadermenu/tablesettings/filter/columnfilter"
import { SYSHeaderMenuFilter } from "./library/table/tablerowheadermenu/tablesettings/filter/filter"
import { SYSHeaderMenuRangeFilter } from "./library/table/tablerowheadermenu/tablesettings/filter/rangefilter"

import { SYSTableRowHeaderMenuDialog } from "./library/table/tablerowheadermenu/tablerowheadermenu"
import { SYSHeaderMenuFilterSortSettings } from "./library/table/tablerowheadermenu/tablesettings/filtersortsettings/filtersortsettings"

import { SYSFormPasswordVisibility } from "../ovlsyscomponents/syslogin01/syspasswordvisibility/syspasswordvisibility"

// don't forget to add the display block in css - file
export const defineElements = () => {
  OvlAddComponent("ovl-screencontainer", SYSScreenContainer)
  OvlAddComponent("ovl-dialogcontainer", SYSDialogContainer)
  OvlAddComponent("ovl-trowcontrol", SYSTableRowControl)
  OvlAddComponent("ovl-tnavcontrol", SYSTableNavControl)
  //AddSYSComponent("ovl-tableview", SYSTableViewControl)
  OvlAddComponent("ovl-table", SYSTableHeader)
  OvlAddComponent("ovl-trow", SYSTableRow)
  OvlAddComponent("ovl-trowvs", SYSTableValidationSummaryRow)
  OvlAddComponent("ovl-trg", SYSTableRowWrapper)
  OvlAddComponent("ovl-trowform", SYSTableRowForm)
  OvlAddComponent("ovl-trowformb", SYSTableRowFormBig)
  /*OvlAddComponent("ovl-trowdetailview", SYSTableRowTableRowDetailView)*/
  OvlAddComponent("ovl-trowsc", SYSTableRowSaveCancel)
  OvlAddComponent("ovl-textarea", SYSTextArea)
  OvlAddComponent("ovl-textbox", SYSTextbox)
  OvlAddComponent("ovl-asset", SYSEditorAsset)
  OvlAddComponent("ovl-checkbox", SYSCheckbox)
  OvlAddComponent("ovl-listcontrol", SYSListControl)
  OvlAddComponent("ovl-option", SYSOption)
  OvlAddComponent("ovl-hitlist", SYSHitList)
  OvlAddComponent("ovl-timebox", SYSTime)
  OvlAddComponent("ovl-datebox", SYSDate)
  OvlAddComponent("ovl-datetimebox", SYSDateTime)
  OvlAddComponent("ovl-dialogholder", SYSDialogHolder)
  OvlAddComponent("ovl-snack", SYSSnack)
  OvlAddComponent("ovl-controlcustomhint", SYSCustomValueHint)
  OvlAddComponent("ovl-controlvalidationhint", SYSValidationHint)
  OvlAddComponent("ovl-formvalidationhint", SYSFormValidationHint)
  OvlAddComponent("ovl-controllabel", SYSControlLabel)
  OvlAddComponent("ovl-tableheadermenu", SYSTableHeaderMenu)
  OvlAddComponent("ovl-okcanceldeletefooter", SYSOkCancelDeleteFooter)
  OvlAddComponent("ovl-headermenufilter", SYSHeaderMenuFilter)
  OvlAddComponent("ovl-headermenurangefilter", SYSHeaderMenuRangeFilter)
  OvlAddComponent("ovl-headermenucolumnfilter", SYSHeaderMenuColumnFilter)
  OvlAddComponent(
    "ovl-headermenufiltersortsettings",
    SYSHeaderMenuFilterSortSettings
  )

  OvlAddComponent("ovl-passwordvisibility", SYSFormPasswordVisibility)

  OvlAddDialog(
    SYSTableSettingsColumnFilterDialog,
    "SYSTableSettings_ColumnFilter"
  )

  OvlAddDialog(SYSTableSettingsFilterSortDialog, "SYSTableSettings_FilterSort")

  OvlAddDialog(SYSDialog, "SYSModal")
  OvlAddDialog(SYSTableRowEditFormDialog, "SYSTableRowEdit")
  OvlAddDialog(SYSHitListDialog, "SYSHitListDialog")
  OvlAddDialog(SYSTableRowHeaderMenuDialog, "SYSTableHeaderMenu")
}
